import styled from 'styled-components'
import { Typography } from 'common/typography'
import Image from 'next/legacy/image'
import { useBadge } from 'querys/course'
import { Timeline, Tween, ScrollTrigger } from 'react-gsap'
import Divider from 'common/divider'
import LightenDarkenColor from 'utils/ligthen-darken-color'
import MedalsPresentation from 'public/images/course/medals-presentation.png'

const BadgeExpositionStyled = styled.section`
  grid-area: badges;
  margin-block-start: 24px;
  img {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    display: block;
  }
  .sara {
    transform: rotateY(180deg);
  }
  .badge-exposition-container {
    position: relative;
  }
  .badge-exposition {
    justify-content: space-between;
    display: flex;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 24px;
  }
  .layer {
    max-width: 50px;
    height: auto;
  }
  .layer-container {
    position: absolute;
    bottom: 0;
    right: calc(50% - 25px);
    max-width: 50px;
    /* filter: drop-shadow(0px 0px 50px ${({ color }) => color}); */
    .layer-overlay {
      position: absolute;
      background: ${({ color }) => `${LightenDarkenColor(color, 160)}`};
      bottom: 0;
      right: 0;
      left: 0;
      top: 0;
      filter: blur(15px);
      border-radius: 50%;
      mix-blend-mode: overlay;
    }
  }
  .glow {
    position: absolute;
    width: 50px;
    height: 50px;
    right: calc(50% - 25px);
    bottom: 0;
    /* background: ${({ color }) => color}; */
    opacity: 0.1;
    border-radius: 50%;
    filter: blur(15px);
  }
  .layer-container {
    &:nth-of-type(1) {
      right: 87.5%;
      bottom: 59px;
      transform: scale(0.9);
    }
    &:nth-of-type(2) {
      right: 78.3%;
      bottom: 22px;
    }
    &:nth-of-type(3) {
      right: 66.7%;
      bottom: 4px;
      transform: scale(1.25);
    }
    &:nth-of-type(4) {
      right: 53.5%;
      transform: scale(1.3);
      bottom: -9px;
    }
    &:nth-of-type(5) {
      right: 35.2%;
      transform: scale(1.45, 1.45);
      bottom: -3px;
    }
    &:nth-of-type(6) {
      right: 16.3%;
      transform: scale(1.5, 1.5);
      bottom: 21px;
    }
  }
  @media(min-width: 768px) {
    .layer {
      max-width: auto;
    }
  }
`

function BadgeExposition() {
  const { data: badgeInfo } = useBadge()

  if (!badgeInfo) return null
  const { badge, badge_layers } = badgeInfo

  if (!badge_layers) return null

  return (
    <BadgeExpositionStyled id="badge-exposition" aria-label="Medallas del curso expuestas por Sara" color={badge.color}>
      <Typography color="var(--baseNeutral)" small="headline6" large="headline5">
        Medalla del curso
      </Typography>
      <Typography font="regular" color="var(--paragraphColor)">
        Mira todas las clases del curso y completa el proyecto para obtener la medalla de:
        {' '}
        {badge.name}
        .
      </Typography>
      <ScrollTrigger
        trigger="#badge-exposition"
        start="top 25%"
        end="+=500px"
        scrub={0.5}
        pin
        pinSpacing="margin"
      >
        <div className="badge-exposition-container">
          <Image
            placeholder="blur"
            width={588}
            height={356}
            src={MedalsPresentation}
            className="sara"
            alt="Sara exponiendo las medallas desplegadas"
          />
          <div className="badge-exposition">
            {badge_layers.map(({ name, image }, index) => (
              <div className="layer-container" id={`${index}-badge`} key={image}>
                <div className="layer">
                  <Image src={image} alt={name} width="80" height="80" loading="lazy" />
                </div>
                <div className="layer-overlay" />
              </div>
            ))}
          </div>
        </div>
      </ScrollTrigger>
      <Divider marginTop={0} marginBottom={24} stroke={1} color="var(--neutral80)" />
    </BadgeExpositionStyled>
  )
}

export default BadgeExposition
